let instance;

class ApiMiddleware {
  constructor() {
    this.headers = process.browser ? new Headers() : {};
    this.eventsQueue = {};

    this.setToken();

    if (!instance) {
      instance = this;

      return instance;
    }

    return instance;
  }

  setToken(token = process.browser && localStorage.getItem('lg')) {
    if (token) {
      this.setHeader('authorization', token);
    }
  }

  getToken() {
    return process.browser && localStorage.getItem('lg');
  }

  setHeader(name, value) {
    this.headers.delete(name);
    this.headers.append(name, value);
  }

  getParsedOptions(options) {
    const parsedOptions = Object.assign({}, options, {
      method: options.method ? options.method.toUpperCase() : 'GET'
    });

    if (options.body) {
      parsedOptions.body = JSON.stringify(options.body);
    }

    parsedOptions.headers = this.headers;

    return parsedOptions;
  }

  getParsedUrl(path, query, apiVersion) {
    const url = new URL(`${process.env.API_URL[apiVersion]}${path}`);

    url.search = new URLSearchParams(query).toString();

    return url;
  }

  async parseData(res) {
    let data = {};

    try {
      data = await res.json();
    } catch (err) {}

    return data;
  }

  async get(path, query, apiVersion) {
    return await this.fetch(path, { query, method: 'GET' }, apiVersion);
  }

  async delete(path, query, apiVersion) {
    return await this.fetch(path, { query, method: 'DELETE' }, apiVersion);
  }

  async post(path, body, apiVersion) {
    return await this.fetch(path, { body, method: 'POST' }, apiVersion);
  }

  async put(path, body, apiVersion) {
    return await this.fetch(path, { body, method: 'PUT' }, apiVersion);
  }

  async patch(path, body, apiVersion) {
    return await this.fetch(path, { body, method: 'PATCH' }, apiVersion);
  }

  async fetch(path, options = {}, apiVersion = 'v1') {
    this.setToken();

    try {
      const res = await fetch(this.getParsedUrl(path, options.query, apiVersion), this.getParsedOptions(options));
      const code = String(res.status)[0];
      const data = await this.parseData(res);

      if (res.status === 401 && data.code === 3) {
        this.emit('unauthorized');
      }

      if (['4', '5'].includes(code)) {
        return {
          status: res.status,
          message: 'Error',
          data
        };
      }

      if (code === '2') {
        return {
          status: res.status,
          message: 'Success',
          data
        };
      }
    } catch (err) {
      return {
        status: 500,
        message: err.message,
        data: {}
      };
    }
  }

  emit(event, data) {
    this.eventsQueue[event].forEach(callback => callback.apply(this, data));
  }

  on(event, callback) {
    this.eventsQueue[event] = this.eventsQueue[event] || [];

    this.eventsQueue[event].push(callback);
  }

  off(event, callback) {
    if (this.eventsQueue[event]?.find(callback)) {
      this.eventsQueue[event] = this.eventsQueue[event].filter(c => c !== callback);
    }
  }
}

export default new ApiMiddleware();
